import { Dashboard } from '@ih/app/shared/apis/interfaces';

export class ShowDeleteConfirmation {
  public static readonly type =
    '[Project/Dashboard/List] ShowDeleteConfirmation';
  constructor(public readonly dashboard: Dashboard) {}
}
